var unresolvedJobs = new Set();

function pushJob(stack, job, pointer) {
  if (!stack[pointer]) stack[pointer] = [];
  stack[pointer].push(job);
}

function batchLayout(callback) {
  unresolvedJobs.add(callback);
  return function () {
    return unresolvedJobs.delete(callback);
  };
}

function flushLayout() {
  if (!unresolvedJobs.size) return;
  var pointer = 0;
  var reads = [[]];
  var writes = [];

  var setRead = function setRead(job) {
    return pushJob(reads, job, pointer);
  };

  var setWrite = function setWrite(job) {
    pushJob(writes, job, pointer);
    pointer++;
  };
  /**
   * Resolve jobs into their array stacks
   */


  unresolvedJobs.forEach(function (callback) {
    callback(setRead, setWrite);
    pointer = 0;
  });
  unresolvedJobs.clear();
  /**
   * Execute jobs
   */

  var numStacks = writes.length;

  for (var i = 0; i <= numStacks; i++) {
    reads[i] && reads[i].forEach(executeJob);
    writes[i] && writes[i].forEach(executeJob);
  }
}

var executeJob = function executeJob(job) {
  return job();
};

export { batchLayout, flushLayout };